import React, { useEffect } from 'react';
import FocusLock from 'react-focus-lock'
import { KeyDownEvent } from '../../../utils/eventKey';
import KrClusterItem from './kr-cluster-item.component';
import { useTranslation } from 'react-i18next';
type clusterPopup ={
    arrowClass: string,
    popupClass: string,
    saveItems: (item?:any, id?:any) => void,
    metric ?: any,
    clusterData ?:any,
    clusterFlag ?:boolean,
    setClusterFlag ?:any,
    iconClass ?:any
    listClass ?:any

};

const KrClusterPopup = (props: clusterPopup) => {
    const {arrowClass = '', popupClass = '', saveItems, metric, clusterData, clusterFlag, setClusterFlag, iconClass = '',listClass = ''} = props;
    const { t } = useTranslation()
    const keyDownHandler = (e) => {
        const parentEl = $("#similar-key-results-obj-kr")
        const isNode = $(e.target).closest(parentEl).length
        if(isNode){
            if (e.key === 'Escape') {
                setClusterFlag(false)
            }
        }
    }

    useEffect(() => {
        window.addEventListener('keydown', keyDownHandler, true);
        return () => {
            window.removeEventListener('keydown', keyDownHandler, true);
            const focusEl = document.getElementById('similar-key-results-control')
            setTimeout(() => {
                if (focusEl) {
                    focusEl.focus()
                }
            }, 0);
        }
    })


    return (
        <>
            <FocusLock>
                <div className={`upArrow ${arrowClass}`}></div>
                <div className={`combinedShape ${popupClass}`}
                    role="dialog"
                    aria-label={t("Similar Key Results")}
                    aria-modal="true"
                    id="similar-key-results-obj-kr"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        KeyDownEvent(e, () => {})
                    }}
                >
                        {
                        clusterFlag && 
                        <div 
                            role="button"
                            tabIndex={0}
                            aria-label={t("close")}
                            className={`icon icon-outline-close-24px KRClusterCloseIcon cursor-pointer ${iconClass}`}
                            onClick={() => setClusterFlag(false)}
                            onKeyDown={(e) => {
                                KeyDownEvent(e, () => setClusterFlag(false))
                            }}
                        />
                        
                        }
                        <div 
                            className='clusterHeaderText'
                            role="heading"
                            aria-level={1}
                        >
                            {t("We've found a few key results that seem similar - take a look!")}
                        </div>
                        <div className={`clusterKrList ${listClass}`}>
                            {
                                (clusterData || metric.clusterItems).map(clusterItem => {
                                    return <KrClusterItem key={clusterItem.id} clusterData={clusterItem} saveItems={saveItems} metric={metric} clusterFlag={clusterFlag}/>
                                })
                            }
                        </div>
                    </div>
            </FocusLock>
        </>
    );
}

export default KrClusterPopup;